<template>
    <div class="travel-notes-container">
        <travel-notes-list></travel-notes-list>

        <div class="container">
            <!-- 航线推荐 -->
            <promo-cruise></promo-cruise>
            <!-- 来稿 -->
            <email-share></email-share>
        </div>
    </div>
</template>

<script>
    import TravelNotesList from '@/components/Review/TravelNotesList'
    import PromoCruise from '@/components/Cruise/PromoCruise'
    import EmailShare from '@/components/Review/EmailShare'

	export default {
		name: 'TravelNotesIndex',
		components: {
            TravelNotesList,
            PromoCruise,
            EmailShare,
        },
		data () {
			return {}
		},
		beforeMount () {},
		methods: {},
	}
</script>

<style lang="less" scoped>
    .travel-notes-container{
        position: relative;
        padding-bottom: 15px;
        background-color: #f5f5f5;
    }
</style>
